import dayjs from 'dayjs'
import { surchargeName, WEEKDAYS } from '@/utils/surcharge'

/**
 * Resolve the surcharge line-item label for an order on the pay page.
 * Reads the PERSISTED descriptor (order.details.surchargeSettings) — never the live clock —
 * so a Saturday surcharge viewed on a Monday still reads "Saturday surcharge".
 * @param {Object} order
 * @returns {string}
 */
export function resolveSurchargeHead(order) {
  const details = (order && order.details) || {}
  const ss = details.surchargeSettings
  if (details.surchargeAmount && ss && ss.type) {
    return surchargeName({
      type: ss.type,
      weekDay: ss.weekDay,
      group: ss.settings && ss.settings.group,
      settings: ss.settings
    })
  }
  // Legacy orders with no surchargeSettings: derive the weekday from the
  // venue-local createdAtString (already local — do NOT apply .tz()).
  if (order && order.createdAtString) {
    const weekDay = WEEKDAYS[dayjs(order.createdAtString).day()]
    return surchargeName({ type: 'weekly', weekDay })
  }
  return surchargeName({ type: 'date' })
}
